// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"layout_pageContainer__28-lH","fixedWidth":"layout_fixedWidth__374gV"};